angular.module('webAgro1App')
  .constant('PHONE_MASK', {
    mask: function(rawValue) {
      if ((rawValue.match(/\d/g) || []).length >= 11) {
        return ['(', /\d/, /\d/, ')', ' ', /\d/, ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
      }
      return ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
    }
  })
  .constant('CPF_MASK', {
    mask: [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/]
  })
  .constant('DATE_MASK', {
    mask: (rawValue) => {
      const splitRaw = rawValue.split('/');

      const rowDay = splitRaw[0];
      const rowMonth = splitRaw[1] || '';
      const rowYear = splitRaw[2] || '';

      let day;
      let month;
      let year;

      // Dia
      if (rowDay.indexOf('3') === 0) {
        day = [/[3]/, /[0-1]/];
      } else if (rowDay.indexOf('0') === 0) {
        day = [/[0]/, /\d/];
      } else {
        day = [/[1-2]/, /\d/];
      }

      // Mês
      if (rowMonth.indexOf('0') === 0) {
        month = [/0/, /[1-9]/];
      } else {
        month = [/[1]/, /[0-2]/];
      }

      // Ano
      if (rowYear.indexOf('2') === 0) {
        year = [/2/, /0/, /[0-4]/, /\d/];
      } else {
        year = [/1/, /\d/, /\d/, /\d/];
      }

      return [].concat(day, '/', month, '/', year);
    }
  })
  .constant('UNITS', {
    hectare: 10000,
    square_meters: 1000,
    toPercent: function(value) {
      if (!value) {
        return 0;
      }

      return value / 100;
    }
  })
  .constant('CONTACT_RENOVATION', '5496350940')
  .constant('MESSAGE_WITHOUT_PRODUCT', 'É necessário adicionar pelo menos um produto para prosseguir.')
  .constant('MESSAGE_INVALID_PRODUCT', 'A dose ou quantidade total dos produtos não pode ser menor que 0.')
  .constant('MIN_DOSE_VALOR', 0.0001)
  .constant('MIN_AREA_VALOR', 0.01)
  .constant('DAYS_SHOW_RENOVATION', 30);
